import React, { useState, useEffect } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { map } from "lodash";
import { BrandDropdown, ProgramDropdown } from "CommonDropdowns";

const Filter = ({ onFilter, extraFiltersState, setExtraFiltersState }) => {
  const [programValue, setProgramValue] = useState([]);
  const [brandValue, setBrandValue] = useState(null);

  // Effect to sync local dropdown values when filters are cleared
  useEffect(() => {
    if (!extraFiltersState.values.program_id) {
      setProgramValue([]);
    }
    if (!extraFiltersState.values.brand_id) {
      setBrandValue(null);
    }
  }, [extraFiltersState.values]);

  const handleClear = () => {
    setExtraFiltersState({ values: {} });
  };

  const handleSearch = () => {
    onFilter();
  };

  const handleProgramChange = (selected) => {
    setProgramValue(selected);
    const programIds = map(selected, "value");
    setExtraFiltersState((prev) => ({
      ...prev,
      values: { ...prev.values, program_id: programIds },
    }));
  };

  const handleBrandChange = (selected) => {
    setBrandValue(selected);
    setExtraFiltersState((prev) => ({
      ...prev,
      values: { ...prev.values, brand_id: selected ? selected.value : null },
    }));
  };

  return (
    <div className="filters-flex pb-2">
      <Row className="align-items-end">
        <Col lg={4}>
          <BrandDropdown
            selectedId={extraFiltersState.values.brand_id || ""}
            value={brandValue}
            setValue={setBrandValue}
            isMulti={false}
            onChange={handleBrandChange}
          />
        </Col>
        <Col lg={4}>
          <Form.Group className="mb-3">
            <ProgramDropdown
              programValue={programValue}
              setProgramValue={setProgramValue}
              isMulti
              selectedId={extraFiltersState.values.program_id}
              programOnChange={handleProgramChange}
            />
          </Form.Group>
        </Col>
        <Col lg={4}>
          <div className="d-flex align-items-end gap-2 mb-3">
            <button
              type="button"
              onClick={handleSearch}
              className="add-new-btn"
              style={{ minWidth: 100 }}
            >
              <img
                src="/assets/images/search-white.svg"
                alt=""
                className="me-2"
              />{" "}
              Search
            </button>
            <button
              type="button"
              onClick={handleClear}
              className="btn btn-secondary"
              style={{ minWidth: 80 }}
            >
              Clear
            </button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Filter;
